import axios from 'axios'

const uploadFiles = async (data,basvuruNo,token) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_BASE_URL+'/api/v1/basvuru/upload/'+basvuruNo,
        headers : { authorization : 'bearer '+token },
        data : data
      };
      
      await axios(config)
      .then(function (res) {
          response = res.data;
      })
      .catch(function (error) {
        console.log(error);
      });
      
      return response
}

export default uploadFiles;
